import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthGuard, CanDeactivateGuard, UserProfileService } from './core';
import { PageNotFoundComponent } from './page-not-found.component';

import { MainComponent } from './main/main.component'
import { NotificationsComponent } from './notifications/notifications.component'
import { AdminComponent } from './admin/admin.component'
import { ReportsComponent } from './reports/reports.component'

import { routes as r1 } from './main/main-routing.module'
import { routes as r2 } from './notifications/notifications-routing.module'
import { routes as r3 } from './admin/admin-routing.module'
import { routes as r4 } from './reports/reports-routing.module'


const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'main', },
  {
    path: 'main',
    children: r1, //loadChildren: 'app/main/main-routing.module#MainRoutingModule',
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    canLoad: [AuthGuard],
    component: MainComponent
  },
  {
    path: 'notifications',
    children: r2, //loadChildren: 'app/notifications/notifications-routing.module#NotificationsRoutingModule',
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    canLoad: [AuthGuard],
    component: NotificationsComponent
  },
  {
    path: 'admin',
    children: r3, //loadChildren: 'app/admin/admin-routing.module#AdminRoutingModule',
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    canLoad: [AuthGuard],
    component: AdminComponent
  },
  {
    path: 'reports',
    children: r4, //loadChildren: 'app/reports/reports-routing.module#ReportsRoutingModule',
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    canLoad: [AuthGuard],
    component: ReportsComponent
  },{
    path: '404', component: PageNotFoundComponent
  },
  { path: '**',redirectTo:"/404" },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule],
  providers: [
    PageNotFoundComponent,
    AuthGuard,
    CanDeactivateGuard
  ]
})
export class AppRoutingModule { }
